export default {
  PROMOTION_NAMES: {
    BAT_YAM: 'bat-yam-first-month-free',
    DISCOUNT_FIRST_MONTH_FREE: 'discount-first-month-free',
  },
};
